import type { TextareaProps as _TextareaProps } from "@chakra-ui/react";
import { forwardRef, Textarea as _Textarea } from "@chakra-ui/react";

export interface TextareaProps extends _TextareaProps {}

export const Textarea = forwardRef<TextareaProps, "textarea">(({ ...props }, ref) => (
    <_Textarea ref={ref} {...props} height={"145px"} py={["2.5", "2.8"]} px={["3", "4"]} />
));
